import { CommonModule } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { TooltipService } from '../shared/tooltip/tooltip.service';
import { FormArray, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { TranslateModule } from '@ngx-translate/core';

import { CaptureDataFormService } from '../capture-data-form/capture-data-form.service';

const LOW_CONFIDENCE_STYLE_CLASS = 'capture-lineitems-form-item--warning';

@Component({
  selector: 'app-capture-data-line-items-form',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputGroupModule,
    InputGroupAddonModule,
    InputTextModule,
    TableModule,
    ButtonModule,
    TooltipModule,
    TranslateModule,
  ],
  templateUrl: './capture-data-line-items-form.component.html',
  styleUrl: './capture-data-line-items-form.component.css',
})
export class CaptureDataLineItemsFormComponent {
  captureDataForm = input.required<FormGroup>();
  lineItemsFormGroupName = input.required<string>();
  lineItemProps = input.required<string[]>();

  private readonly captureDataFormService = inject(CaptureDataFormService);
  private readonly tooltipService = inject(TooltipService);

  get lineItemForm(): FormArray | null {
    const form = this.captureDataForm();
    if (!form) {
      return null;
    }
    return form.get(this.lineItemsFormGroupName()) as FormArray;
  }

  get lineItemControls(): FormGroup[] {
    const form = this.lineItemForm;
    if (!form) {
      return [];
    }
    return form.controls as FormGroup[];
  }

  getFormFieldClassConfidenceByFormGroupName(formGroup: FormGroup, formGroupName: string): string {
    if (this.captureDataFormService.isCaptureDataFieldLowConfident(formGroup, formGroupName)) {
      return LOW_CONFIDENCE_STYLE_CLASS;
    }
    return '';
  }

  getConfidenceByFormGroupName(formGroup: FormGroup, formGroupName: string) {
    return this.captureDataFormService.getCaptureFieldConfidenceByProp(formGroup, formGroupName);
  }

  addLineItemForm(): void {
    this.captureDataFormService.addLineItemForm(this.lineItemForm!, this.lineItemProps());
  }

  removeLineItemRowFromIndex(index: number) {
    this.captureDataFormService.removeLineItemFormByIndex(this.lineItemForm!, index);
  }

  getTooltipText(prop: string): string {
    return this.tooltipService.getTooltip(prop);
  }
}
